import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
import mobilePlan from "@static/img/home/offer.png";
import "@features/home/css/home.scss";
import { HomeOfferList } from "@features/home/HomeOfferList";

export const HomePage = () => {
    const { t } = useTranslation("home");

    return (
        <div className="home-container">
            <Grid className="home-wrapper" container direction="column-reverse">
                <Grid className="home-wrapper__text" item lg={6} md={8} sm={10} style={{ zIndex: 100 }} xs={12}>
                    <Typography color="inherit" gutterBottom variant="h1">
                        {t("ourPlan")}
                    </Typography>
                    <Typography className="home-wrapper__description" color="inherit" gutterBottom variant="body1">
                        {t("homeInfo")}
                    </Typography>
                    <HomeOfferList />
                </Grid>
                <Grid item xs={5}>
                    <div className="home__circle" />
                </Grid>
            </Grid>
            <img alt="Mobile plan" className="home-container__image" src={mobilePlan} />
            <div className="home-container-cover" />
        </div>
    );
};
